import { FC, ReactElement } from 'react';

import { Skeleton } from '../../../../../../../components';

import './ProductVariantsSkeletons.scss';

interface ProductVariantsSkeletonsProps {
    className?: string;
}

export const ProductVariantsSkeletons: FC<ProductVariantsSkeletonsProps> = ({
    className = '',
}): ReactElement => (
    <div className={`product-variants-skeletons ${className}`}>
        <Skeleton className="product-variants-skeletons__skeleton" />
    </div>
);
